/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ItemTransactionType = "ADD" | "DEDUCT" | "PURCHASE_RECEIPT" | "TRANSFER";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddItemMovementModal_item$ref: FragmentReference;
declare export opaque type AddItemMovementModal_item$fragmentType: AddItemMovementModal_item$ref;
export type AddItemMovementModal_item = {|
  +id: string,
  +itemNumber: string,
  +totalQty: number,
  +quantityUOM: {|
    +id: string,
    +name: string,
  |},
  +logs: $ReadOnlyArray<{|
    +id: string,
    +user: {|
      +id: string
    |},
    +lot: {|
      +id: string
    |},
    +fromLot: ?{|
      +id: string
    |},
    +operation: ItemTransactionType,
    +quantity: number,
    +notes: ?string,
    +createdAt: any,
  |}>,
  +lots: {|
    +edges: ?$ReadOnlyArray<?{|
      +quantity: ?number,
      +node: {|
        +id: string,
        +lotNumber: string,
      |},
    |}>
  |},
  +lotTracking: ?boolean,
  +$refType: AddItemMovementModal_item$ref,
|};
export type AddItemMovementModal_item$data = AddItemMovementModal_item;
export type AddItemMovementModal_item$key = {
  +$data?: AddItemMovementModal_item$data,
  +$fragmentRefs: AddItemMovementModal_item$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddItemMovementModal_item",
  "type": "Item",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "lots"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "itemNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalQty",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quantityUOM",
      "storageKey": null,
      "args": null,
      "concreteType": "UOM",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "logs",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemTransactionLog",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "lot",
          "storageKey": null,
          "args": null,
          "concreteType": "Lot",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "fromLot",
          "storageKey": null,
          "args": null,
          "concreteType": "Lot",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "operation",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "lots",
      "name": "__Item_lots_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemLotConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemLotEdge",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Lot",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lotNumber",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lotTracking",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '14c4dd7eed8cecfdcd3c2568baf7d178';
module.exports = node;
